// FileCardSkeleton.tsx
import { Box, Skeleton, Stack } from '@mui/material';
import React from 'react';

const FileCardSkeleton: React.FC = () => {
    return (
        <Box
            sx={{
                width: '100%',
                height: '187px',
                border: '1px solid #cbcbcb',
                borderRadius: '16px',
                overflow: 'hidden',
                backgroundColor: 'white',
            }}>
            {/* Preview Area Skeleton */}
            <Box
                sx={{
                    height: '123px',
                    borderBottom: '1px solid #cbcbcb',
                    backgroundColor: '#f9f9f9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
            </Box>

            {/* File Info Skeleton */}
            <Box
                sx={{
                    padding: '9px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '4px',
                }}>
                <Stack spacing={0.4} sx={{ flex: 1 }}>
                    <Skeleton variant="text" width="80%" height={16} />
                    <Skeleton variant="text" width="40%" height={14} />
                </Stack>
                <Skeleton variant="circular" width={24} height={24} sx={{ marginTop: '5px' }} />
            </Box>
        </Box>
    );
};

export default FileCardSkeleton;
